import { ComparisonFeeGroupings } from '../comparison-fee-groupings/comparison-fee-groupings.model';
import { FeeGroupings } from '../fee-groupings/fee-groupings.model';
import { StatementStructureTypeEnum } from '../statement/statement.model';

export interface StatementDataObject {
    statementId: string;
    statementName: string;
}

/** Display labels for fee groupings (e.g. "Processor Fees"). Sourced from statement or defaults. */
export interface FeeGroupingFriendlyNames {
    processor?: string;
    additional?: string;
    assessment?: string;
    nonNegotiable?: string;
    interchange?: string;
}

export interface RateGroup {
    label: string;
    transactionRate: number;
    transactionFee?: number;
}

export class CostComparison {
    constructor(cc: Partial<CostComparison>) {
        Object.keys(this).forEach(key => {
            if (this[key as keyof CostComparison] == null && cc[key as keyof CostComparison] == null)
                throw new Error(`${key} cannot be null`);
        });
        Object.assign(this, cc);
    }
    id: string | null = null;
    index: number | null = null;

    createdAt: Date | null = null;
    updatedAt: Date | null = null;

    friendlyName: string | null = null;

    notes: string | null = null;

    statementData: Array<StatementDataObject> | null = null;

    originalStructure: StatementStructureTypeEnum | null = null;
    proposedStructure: StatementStructureTypeEnum | null = null;

    rateGroups: Array<RateGroup>|undefined; 

    originalFeeGroupings: Array<FeeGroupings> | null = null;

    /** Friendly names for display (section headers). Populated from originalFeeGroupings[0] when present. */
    feeGroupingFriendlyNames?: FeeGroupingFriendlyNames;

    comparisonFeeGroupings: ComparisonFeeGroupings | null = null;
}

/** True if at least one key has a non-empty value. */
export function hasFeeGroupingFriendlyNames(fn: FeeGroupingFriendlyNames | null | undefined): boolean {
    if (!fn || typeof fn !== 'object') return false;
    const keys: (keyof FeeGroupingFriendlyNames)[] = ['processor', 'additional', 'assessment', 'nonNegotiable', 'interchange'];
    return keys.some(k => fn[k] != null && fn[k] !== '');
}

/** Derive friendly names from the first fee groupings entry for display. */
export function feeGroupingFriendlyNamesFrom(first: FeeGroupings): FeeGroupingFriendlyNames {
    if (!first) return {};
    return {
        processor: first.processor?.friendlyName,
        additional: first.additional?.friendlyName,
        assessment: first.assessment?.friendlyName,
        nonNegotiable: first.nonNegotiable?.friendlyName,
        interchange: first.interchange?.friendlyName
    };
}

export const sortCostComparisons = (a: CostComparison, b: CostComparison) =>
    (a.index ?? 0) - (b.index ?? 0);

